import { z } from 'zod';

import { FormPreviewItem } from 'app/models/Common';

export const DRIVE_FOLDER_FORM_SCHEMA = z
  .object({
    name: z
      .string()
      .min(1, { message: '必填' })
      .regex(/^((?!\/).)*$/, '錯誤的Folder名稱')
      .max(255, { message: '超出字數上限' }),
    image: z
      .array(
        z.instanceof(File)
          .or(z.custom<FormPreviewItem>()),
      ),
    isAlbumMode: z.boolean(),
    title: z.string().optional(),
    description: z.string().optional(),
    date: z.date().nullish(),
    time: z
      .object({
        hour: z.string(),
        minute: z.string(),
      }).optional(),
    location: z.string().optional(),
    eventId: z.number().nullable(),
  }).refine(({ isAlbumMode, title }) => !isAlbumMode || title, {
    message: '請選擇活動或填寫活動名稱',
    path: ['title'],
  });

export type DriveFolderFormDataType = z.infer<typeof DRIVE_FOLDER_FORM_SCHEMA>;
